// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaticBlockForm-space1-OTlM4 {
	margin-bottom: 6px !important;
}

.StaticBlockForm-space2-VFpvR {
	margin-bottom: 12px !important;
}

.StaticBlockForm-space3-SPgPQ {
	margin-bottom: 18px !important;
}

.StaticBlockForm-space4-PeyF_ {
	margin-bottom: 24px !important;
}

.StaticBlockForm-space5-QoSU7 {
	margin-bottom: 30px !important;
}

.StaticBlockForm-space6-KY2O9 {
	margin-bottom: 36px !important;
}

.StaticBlockForm-space7-p5ssf {
	margin-bottom: 42px !important;
}

.StaticBlockForm-space8-cbiBu {
	margin-bottom: 48px !important;
}

.StaticBlockForm-spaceTop1-eId2C {
	margin-top: 6px !important;
}

.StaticBlockForm-spaceTop2-OmgY8 {
	margin-top: 12px !important;
}

.StaticBlockForm-spaceTop3-nkHH7 {
	margin-top: 18px !important;
}

.StaticBlockForm-spaceTop4-GvtCw {
	margin-top: 24px !important;
}

.StaticBlockForm-spaceTop5-ZUdi3 {
	margin-top: 30px !important;
}

.StaticBlockForm-spaceTop6-re7EM {
	margin-top: 36px !important;
}

.StaticBlockForm-spaceTop7-F_por {
	margin-top: 42px !important;
}

.StaticBlockForm-spaceTop8-Cm4MQ {
	margin-top: 48px !important;
}

.StaticBlockForm-noMargin-ZsJL5 {
	margin: 0px !important;
}

.StaticBlockForm-padding1-Ql0lK {
	padding-bottom: 6px !important;
}

.StaticBlockForm-padding2-K_hTQ {
	padding-bottom: 12px !important;
}

.StaticBlockForm-padding3-HUZKd {
	padding-bottom: 18px !important;
}

.StaticBlockForm-padding4-zOhdx {
	padding-bottom: 24px !important;
}

.StaticBlockForm-padding5-sHjtO {
	padding-bottom: 30px !important;
}

.StaticBlockForm-padding6-KoJAc {
	padding-bottom: 36px !important;
}

.StaticBlockForm-padding7-Ekej1 {
	padding-bottom: 42px !important;
}

.StaticBlockForm-paddingTop1-TcB2m {
	padding-top: 6px !important;
}

.StaticBlockForm-paddingTop2-Lgq9g {
	padding-top: 12px !important;
}

.StaticBlockForm-paddingTop3-kf461 {
	padding-top: 18px !important;
}

.StaticBlockForm-paddingTop4-FgmYh {
	padding-top: 24px !important;
}

.StaticBlockForm-paddingTop5-fBMaB {
	padding-top: 30px !important;
}

.StaticBlockForm-paddingTop6-SL9Aj {
	padding-top: 36px !important;
}

.StaticBlockForm-paddingTop7-id5tR {
	padding-top: 42px !important;
}

.StaticBlockForm-noPadding-V58Ww {
	padding: 0px !important;
}

.StaticBlockForm-spaceMarginBottom0-K_7IZ {
	margin-bottom: 0;
}

.StaticBlockForm-textBold-lmNIm {
	font-weight: 500 !important;
}

.StaticBlockForm-textBolder-FPNiL {
	font-weight: 700 !important;
}

.StaticBlockForm-textNormal-lsAZO {
	font-weight: normal !important;
}

/*New Design Text Colors */

.StaticBlockForm-textDarkBlue-qxCYB {
	color: rgb(20, 39, 94) !important;
}

.StaticBlockForm-textLightBlue-EDTym {
	color: rgb(57, 87, 106) !important;
}

.StaticBlockForm-textLightSandleGreen-zrPcG {
	color: rgb(76, 86, 41) !important;
}

.StaticBlockForm-textLightBrown-vLrTr {
	color: rgb(115, 79, 33) !important;
}

.StaticBlockForm-textMediumMaroon-XLBzA {
	color: rgb(87, 37, 51) !important;
}

.StaticBlockForm-textBrown-lKxjq {
	color: rgb(160, 47, 24) !important;
}

.StaticBlockForm-textMaroon-D8hN_ {
	color: rgb(155, 49, 67) !important;
}

.StaticBlockForm-textDarkBrown-sziHv {
	color: rgb(83, 18, 16) !important;
}

.StaticBlockForm-textMediumBrown-gXdtp {
	color: rgb(142, 28, 10) !important;
}

.StaticBlockForm-textSkyBlue-zbFmB {
	color: rgb(37, 117, 141) !important;
}

.StaticBlockForm-textGray-el0Oj {
	color: rgb(77, 65, 51) !important;
}

.StaticBlockForm-errorMessage-hsZfW {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.StaticBlockForm-userText-qjEXI {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.StaticBlockForm-panelHeader-O17J9 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.StaticBlockForm-exportSection-lA8tJ {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.StaticBlockForm-exportSectionGridSub-ZcBf1 {
	grid-template-columns: 50% 49% !important;
}

.StaticBlockForm-exportText-Vpeae {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.StaticBlockForm-exportLinkImg-hjILQ {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.StaticBlockForm-exportImg-VfTXz {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.StaticBlockForm-linkBtn-mjG6J {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.StaticBlockForm-table-jbFYH {
	display: table;
}

.StaticBlockForm-tableRow-bxC4M {
	display: table-row;
}

.StaticBlockForm-tableCell-plkRP {
	display: table-cell;
	float: none;
}

.StaticBlockForm-formGroup-o0yik {
	margin-bottom: 6px;
}

.StaticBlockForm-marginTop0-vihNw {
	margin-top: 0;
}

.StaticBlockForm-marginBottom20-w9AZm {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.StaticBlockForm-bannerImageBg-JQ1kK {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.StaticBlockForm-bannerDelete-lhvgN {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.StaticBlockForm-exportLink-IickN {
	padding-top: 10px;
	padding-right: 10px;
}

.StaticBlockForm-seachContent-gEp82 {
	padding-left: 0px;
	margin-bottom: 5px;
}

.StaticBlockForm-marginBottom9-OA2rt {
	margin-bottom: 9px;
}

.StaticBlockForm-spaceTop52-sU3HD {
	margin-top: 52px;
}

.StaticBlockForm-profileViewInner-hYQAG {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.StaticBlockForm-profileViewMain-hwGPQ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.StaticBlockForm-profileViewlabel-gzThf {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.StaticBlockForm-profileViewMainContent-jfxOg {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.StaticBlockForm-reviewsFormStar-GNiD_ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.StaticBlockForm-reviewsFormStar-GNiD_ svg {
	cursor: pointer;
}

.StaticBlockForm-addLanguageText-NoOpU {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.StaticBlockForm-exportSection-lA8tJ {
		grid-template-columns: 100%;
	}

	.StaticBlockForm-spaceTop52-sU3HD {
		margin-top: 18px;
	}

	.StaticBlockForm-exportText-Vpeae {
		float: none;
		margin-top: 12px;
	}

	.StaticBlockForm-exportSectionGridSub-ZcBf1 {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.StaticBlockForm-profileViewlabel-gzThf {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.StaticBlockForm-profileViewMainContent-jfxOg {
		width: 100%;
		text-align: center;
	}

	.StaticBlockForm-panelHeader-O17J9 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.StaticBlockForm-staticBlockFormCard-XdKIT {
    border: 1px solid var(--border-secondary-color);
    border-radius: 6px;
    margin-bottom: 25px;
    padding: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/StaticBlockForm/StaticBlockForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.staticBlockFormCard {\n    border: 1px solid var(--border-secondary-color);\n    border-radius: 6px;\n    margin-bottom: 25px;\n    padding: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `StaticBlockForm-space1-OTlM4`,
	"space2": `StaticBlockForm-space2-VFpvR`,
	"space3": `StaticBlockForm-space3-SPgPQ`,
	"space4": `StaticBlockForm-space4-PeyF_`,
	"space5": `StaticBlockForm-space5-QoSU7`,
	"space6": `StaticBlockForm-space6-KY2O9`,
	"space7": `StaticBlockForm-space7-p5ssf`,
	"space8": `StaticBlockForm-space8-cbiBu`,
	"spaceTop1": `StaticBlockForm-spaceTop1-eId2C`,
	"spaceTop2": `StaticBlockForm-spaceTop2-OmgY8`,
	"spaceTop3": `StaticBlockForm-spaceTop3-nkHH7`,
	"spaceTop4": `StaticBlockForm-spaceTop4-GvtCw`,
	"spaceTop5": `StaticBlockForm-spaceTop5-ZUdi3`,
	"spaceTop6": `StaticBlockForm-spaceTop6-re7EM`,
	"spaceTop7": `StaticBlockForm-spaceTop7-F_por`,
	"spaceTop8": `StaticBlockForm-spaceTop8-Cm4MQ`,
	"noMargin": `StaticBlockForm-noMargin-ZsJL5`,
	"padding1": `StaticBlockForm-padding1-Ql0lK`,
	"padding2": `StaticBlockForm-padding2-K_hTQ`,
	"padding3": `StaticBlockForm-padding3-HUZKd`,
	"padding4": `StaticBlockForm-padding4-zOhdx`,
	"padding5": `StaticBlockForm-padding5-sHjtO`,
	"padding6": `StaticBlockForm-padding6-KoJAc`,
	"padding7": `StaticBlockForm-padding7-Ekej1`,
	"paddingTop1": `StaticBlockForm-paddingTop1-TcB2m`,
	"paddingTop2": `StaticBlockForm-paddingTop2-Lgq9g`,
	"paddingTop3": `StaticBlockForm-paddingTop3-kf461`,
	"paddingTop4": `StaticBlockForm-paddingTop4-FgmYh`,
	"paddingTop5": `StaticBlockForm-paddingTop5-fBMaB`,
	"paddingTop6": `StaticBlockForm-paddingTop6-SL9Aj`,
	"paddingTop7": `StaticBlockForm-paddingTop7-id5tR`,
	"noPadding": `StaticBlockForm-noPadding-V58Ww`,
	"spaceMarginBottom0": `StaticBlockForm-spaceMarginBottom0-K_7IZ`,
	"textBold": `StaticBlockForm-textBold-lmNIm`,
	"textBolder": `StaticBlockForm-textBolder-FPNiL`,
	"textNormal": `StaticBlockForm-textNormal-lsAZO`,
	"textDarkBlue": `StaticBlockForm-textDarkBlue-qxCYB`,
	"textLightBlue": `StaticBlockForm-textLightBlue-EDTym`,
	"textLightSandleGreen": `StaticBlockForm-textLightSandleGreen-zrPcG`,
	"textLightBrown": `StaticBlockForm-textLightBrown-vLrTr`,
	"textMediumMaroon": `StaticBlockForm-textMediumMaroon-XLBzA`,
	"textBrown": `StaticBlockForm-textBrown-lKxjq`,
	"textMaroon": `StaticBlockForm-textMaroon-D8hN_`,
	"textDarkBrown": `StaticBlockForm-textDarkBrown-sziHv`,
	"textMediumBrown": `StaticBlockForm-textMediumBrown-gXdtp`,
	"textSkyBlue": `StaticBlockForm-textSkyBlue-zbFmB`,
	"textGray": `StaticBlockForm-textGray-el0Oj`,
	"errorMessage": `StaticBlockForm-errorMessage-hsZfW`,
	"userText": `StaticBlockForm-userText-qjEXI`,
	"panelHeader": `StaticBlockForm-panelHeader-O17J9`,
	"exportSection": `StaticBlockForm-exportSection-lA8tJ`,
	"exportSectionGridSub": `StaticBlockForm-exportSectionGridSub-ZcBf1`,
	"exportText": `StaticBlockForm-exportText-Vpeae`,
	"exportLinkImg": `StaticBlockForm-exportLinkImg-hjILQ`,
	"exportImg": `StaticBlockForm-exportImg-VfTXz`,
	"linkBtn": `StaticBlockForm-linkBtn-mjG6J`,
	"table": `StaticBlockForm-table-jbFYH`,
	"tableRow": `StaticBlockForm-tableRow-bxC4M`,
	"tableCell": `StaticBlockForm-tableCell-plkRP`,
	"formGroup": `StaticBlockForm-formGroup-o0yik`,
	"marginTop0": `StaticBlockForm-marginTop0-vihNw`,
	"marginBottom20": `StaticBlockForm-marginBottom20-w9AZm`,
	"bannerImageBg": `StaticBlockForm-bannerImageBg-JQ1kK`,
	"bannerDelete": `StaticBlockForm-bannerDelete-lhvgN`,
	"exportLink": `StaticBlockForm-exportLink-IickN`,
	"seachContent": `StaticBlockForm-seachContent-gEp82`,
	"marginBottom9": `StaticBlockForm-marginBottom9-OA2rt`,
	"spaceTop52": `StaticBlockForm-spaceTop52-sU3HD`,
	"profileViewInner": `StaticBlockForm-profileViewInner-hYQAG`,
	"profileViewMain": `StaticBlockForm-profileViewMain-hwGPQ`,
	"profileViewlabel": `StaticBlockForm-profileViewlabel-gzThf`,
	"profileViewMainContent": `StaticBlockForm-profileViewMainContent-jfxOg`,
	"reviewsFormStar": `StaticBlockForm-reviewsFormStar-GNiD_`,
	"addLanguageText": `StaticBlockForm-addLanguageText-NoOpU`,
	"staticBlockFormCard": `StaticBlockForm-staticBlockFormCard-XdKIT`
};
module.exports = ___CSS_LOADER_EXPORT___;
